<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <ValidationObserver v-slot="{ passed, failed }">
          <form>
            <md-card class="p-25">
              <md-card-content>
                <div class="md-layout">
                  <div
                    v-if="id == ''"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <label>المستهدف</label>
                      <md-select v-model="IsAllEmployees">
                        <md-option :value="true">كافة الموظفين</md-option>
                        <md-option :value="false">موظف واحد</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    v-if="id != ''"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <label>المستهدف</label>
                      <md-select disabled v-model="IsAllEmployees">
                        <md-option :value="true">كافة الموظفين</md-option>
                        <md-option :value="false">موظف واحد</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    v-if="!IsAllEmployees && id == ''"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25 clear-relative"
                    style="position: relative"
                  >
                    <p
                      style="
                        position: absolute;
                        top: -3px;
                        right: 2px;
                        color: red;
                      "
                    >
                      *
                    </p>
                    <model-list-select
                      class="input-must-rtl"
                      :list="employees"
                      v-model="EmployeeId"
                      option-value="key"
                      option-text="value"
                      placeholder="الموظف"
                    >
                    </model-list-select>
                    <ClearButton
                      class="absolute-clear-button"
                      @click.native="clearfield('EmployeeId')"
                    />
                  </div>

                  <div
                    v-if="id != ''"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>الموظف</label>
                      <md-input disabled v-model="employeeFullName"></md-input>
                    </md-field>
                  </div>
                  <!-- v-show="showType" v-if="IsAllEmployees != 'true' && id == ''" -->
                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mtb-25"
                  >
                    <md-field>
                      <p class="validate">*</p>

                      <label>نوع الإجازة</label>
                      <md-select
                        :disabled="!IsAllEmployees && !EmployeeId"
                        v-model="TypeId"
                      >
                        <md-option
                          v-for="Type in allTypes"
                          v-bind:key="Type.id"
                          :value="Type.id"
                          >{{ Type.name }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    v-if="IsAllEmployees != 'true'"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>رصيد الإجازة</label>
                      <md-input disabled v-model="balance"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                  >
                    <md-datepicker :md-open-on-focus="false" v-model="StartOn">
                      <p class="validate">*</p>

                      <label class="mr-28">من تاريخ</label>
                    </md-datepicker>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                  >
                    <md-datepicker :md-open-on-focus="false" v-model="FinishOn">
                      <p class="validate">*</p>

                      <label class="mr-28">الى تاريخ</label>
                    </md-datepicker>
                  </div>

                  <div
                    v-if="id != ''"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <label>نوع الإجازة</label>
                      <md-select disabled v-model="TypeId">
                        <md-option
                          v-for="Type in Type"
                          v-bind:key="Type.id"
                          :value="Type.id"
                          >{{ Type.name }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    v-if="!IsAllEmployees"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25 clear-relative"
                    style="position: relative"
                  >
                    <model-list-select
                      class="input-must-rtl"
                      :list="employees"
                      v-model="actingEmployee"
                      option-value="key"
                      option-text="value"
                      placeholder="اسم الموظف البديل"
                    >
                    </model-list-select>
                    <ClearButton
                      v-if="actingEmployee"
                      class="absolute-clear-button"
                      @click.native="clearfield('actingEmployee')"
                    />
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>ملاحظة</label>
                      <md-input v-model="Note"></md-input>
                    </md-field>
                  </div>

                  <div
                    v-if="id != ''"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>مدة الاجازة</label>
                      <md-input disabled v-model="duration"></md-input>
                    </md-field>
                  </div>

                  <div
                    v-if="id != ''"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>مدة الاجازة الفعلية</label>
                      <md-input
                        disabled
                        v-model="actualDiscountDuration"
                      ></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-100 mt-25 mtb-25 center-content"
                  >
                    <!-- <md-button v-if="id == ''" @click="clear" class="md-info btn_nanosoft"
                    >جديد</md-button
                  > -->
                    <md-button
                      v-show="btnLoaded"
                      @click="Save"
                      class="md-success btn_nanosoft"
                      >حفظ</md-button
                    >
                    <md-button
                      v-if="typeName == 'إجازة سنوية'"
                      @click="Pdf"
                      class="md-success btn_nanosoft"
                      >طباعة pdf</md-button
                    >
                    <md-button
                      v-if="typeName == 'إجازة سنوية'"
                      @click="Word"
                      class="md-success btn_nanosoft"
                      >طباعة word</md-button
                    >
                    <md-button @click="gobBack" class="md-info btn_nanosoft"
                      >رجوع</md-button
                    >
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <div v-if="id == '' && IsAllEmployees == 'true'" class="md-layout-item">
      <md-card>
        <md-card-content>
          <div class="md-layout flex-content-left">
            <div class="md-size-15 md-layout-item mt-25">
              <md-table-toolbar>
                <md-field>
                  <label for="pages">عدد النتائج</label>
                  <md-select v-model="pagination.perPage" name="pages">
                    <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                      >{{ item }}</md-option
                    >
                  </md-select>
                </md-field>
              </md-table-toolbar>
            </div>
          </div>

          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="المستهدف">{{
                item.employeeFullName
              }}</md-table-cell>

              <md-table-cell md-label="نوع الإجازة">{{
                item.typeName
              }}</md-table-cell>

              <md-table-cell md-label="بداية العطلة">{{
                convert(item.startOn)
              }}</md-table-cell>

              <md-table-cell md-label="نهاية العطلة">{{
                convert(item.finishOn)
              }}</md-table-cell>

              <md-table-cell md-label="ملاحظة">{{ item.note }}</md-table-cell>

              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
                <!-- <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>dvr</md-icon>
                </md-button> -->
                <!-- <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button> -->
              </md-table-cell>
            </md-table-row>
          </md-table>
          <!-- <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">{{ item }}</div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div> -->
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>

    <div v-if="id != ''" class="md-layout-item">
      <md-card>
        <md-card-content>
          <div class="md-layout flex-content-left">
            <div class="md-size-15 md-layout-item mt-25">
              <md-table>
                <md-table-toolbar>
                  <md-field>
                    <label for="pages">عدد النتائج</label>
                    <md-select v-model="pagination.perPage" name="pages">
                      <md-option
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                        >{{ item }}</md-option
                      >
                    </md-select>
                  </md-field>
                </md-table-toolbar>
              </md-table>
            </div>
          </div>

          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="الموظف">{{
                item.employeeFullName
              }}</md-table-cell>

              <md-table-cell md-label="رقم الملاك الوظيفي">{{
                item.employeeNumber
              }}</md-table-cell>

              <md-table-cell md-label="نوع الإجازة">{{
                item.typeName
              }}</md-table-cell>

              <md-table-cell md-label="بداية الإجازة">{{
                convert(item.startOn)
              }}</md-table-cell>

              <md-table-cell md-label="انتهاء الإجازة">{{
                convert(item.finishOn)
              }}</md-table-cell>

              <md-table-cell md-label="ملاحظة">{{ item.note }}</md-table-cell>

              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
                <!-- <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>dvr</md-icon>
                </md-button> -->
                <!-- <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button> -->
              </md-table-cell>
            </md-table-row>
          </md-table>
          <!-- <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">{{ item }}</div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div> -->
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from "../../../../components/service/HTTP";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";

// import { ModelListSelect } from "vue-search-select";
// import { SlideYDownTransition } from "vue2-transitions";
// import { extend } from "vee-validate";
// import { required, numeric, regex, confirmed } from "vee-validate/dist/rules";
import env from "../../../../../env";
// extend("required", required);
// extend("numeric", numeric);
// extend("regex", regex);
// extend("confirmed", confirmed);
export default {
  async created() {
    this.init();
  },
  components: {
    Pagination,
    ModelListSelect,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      showType: false,
      typeName: "",
      errorMessage: "",
      btnLoaded: true,
      id: localStorage.getItem("idTable"),
      IsAll: false,
      IsAllEmployees: false,
      EmployeeId: null,
      actingEmployee: null,
      TypeId: null,
      StartOn: null,
      FinishOn: null,
      Note: "",
      allTypes: [],
      employeeFullName: "",
      tableData: [],
      btn: "new",
      idTable: "",
      employees: [],
      updateStatus: "",
      balance: 0,
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["Titel", "Severity", "Status"],
      searchedData: [],
      fuseSearch: null,
      currentSortOrder: "asc",
      currentSort: "",
    };
  },

  methods: {
    clearfield(field) {
      this[field] = null;
    },
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },

    async Pdf() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let id = localStorage.getItem("idTable");

        let result = await axios.get(
          `${env.HR()}/api/hr/Vacations/AnnualVacationPdf?id=${id}&ReportType=Pdf`,

          {
            headers: { Authorization: "Bearer " + token },
            responseType: "blob",
          }
        );
        // Create a new Blob object using the response data
        const blob = new Blob([result.data], { type: "application/pdf" });

        // Create a link element
        const link = document.createElement("a");

        // Create a URL for the Blob and set it as the href attribute of the link
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        // Set the download attribute with a filename
        link.download = "تقرير اشعار الإجازة.pdf";

        // Append the link to the document body (it won't be visible)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up by removing the link and revoking the object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.lodding_bool = false;
      } catch (error) {
        console.error("Error downloading the PDF", error);
        this.lodding_bool = false;
      }
    },

    async Word() {
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let id = localStorage.getItem("idTable");
      let result = await axios.get(
        `${env.HR()}/api/hr/Vacations/AnnualVacationPdf?id=${id}&ReportType=Word`,
        {
          headers: { Authorization: "Bearer " + token },

          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([result.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "  اشعار الإجازة.doc");
      document.body.appendChild(link);
      link.click();
    },

    async Save() {
      if (this.btnLoaded == false) {
        return;
      }

      let id = localStorage.getItem("idTable");
      try {
        let T = localStorage.getItem("Nannotoken");

        if (!this.EmployeeId && !this.IsAllEmployees) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار الموظف   "
          );
        }

        if (!this.StartOn) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء تحديد التاريخ "
          );
        }

        if (!this.FinishOn) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء تحديد التاريخ "
          );
        }

        if (!this.TypeId && !this.IsAllEmployees) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار نوع الإجازة "
          );
        }

        let token = atob(T);

        let schema = {
          IsAllEmployees: this.IsAllEmployees,
          EmployeeId: this.EmployeeId,
          actingEmployee: this.actingEmployee,
          TypeId: this.TypeId,
          StartOn: moment(this.StartOn).format("YYYY-MM-DD[T]hh:mm:ss"),
          FinishOn: moment(this.FinishOn).format("YYYY-MM-DD[T]hh:mm:ss"),
          Note: this.Note,
        };
        this.btnLoaded = false;
        if (this.btn === "new" && id === "") {
          let result = await axios.post(
            `${env.HR()}/api/hr/Vacations`,
            schema,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
        } else {
          let result = await axios.put(
            `${env.HR()}/api/hr/Vacations/${id}`,
            schema,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
        }
        this.btn = "new";
        this.$router.push("/pages/vacations");
        // this.init();
        this.clear();
        this.btnLoaded = true;
        return this.notifyVue("top", "center", "success", " تم الحفظ بنجاح ");
      } catch (error) {
        this.btnLoaded = true;
        this.message(error);
      }
    },

    message(error) {
      if (error.response.data.message != undefined) {
        this.errorMessage = error.response.data.message;
      } else {
        this.errorMessage =
          error.response.data.errors[
            Object.keys(error.response.data.errors)[0]
          ][0];
      }

      return this.notifyVue("top", "center", "danger", this.errorMessage);
    },

    async init() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let id = localStorage.getItem("idTable");

        let token = atob(T);

        if (id == "") {
          let result_new = await axios.get(`${env.HR()}/api/hr/Vacations/new`, {
            headers: { Authorization: "Bearer " + token },
          });
          this.tableData = result_new.data.data.allVacations;
          this.employees = result_new.data.data.employees;
          this.allTypes = result_new.data.data.types;
        } else {
          let result = await axios.get(`${env.HR()}/api/hr/Vacations/${id}`, {
            headers: { Authorization: "Bearer " + token },
          });

          this.EmployeeId = result.data.data.employeeId;
          this.actingEmployee = result.data.data.actingEmployee;
          (this.TypeId = result.data.data.typeId),
            (this.StartOn = new Date(result.data.data.startOn)),
            (this.FinishOn = new Date(result.data.data.finishOn)),
            (this.Note = result.data.data.note);
          this.balance = result.data.data.vacationInfo.balance;
          this.employeeFullName = result.data.data.employeeFullName;
          this.employees = result.data.data.employees;
          this.allTypes = result.data.data.types;
          this.tableData = result.data.data.employeeVacations;
          this.actualDiscountDuration = result.data.data.actualDiscountDuration;
          this.duration = result.data.data.duration;
          this.typeName = result.data.data.typeName;

          // this.tableData = result.data.data;
        }
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },

    gobBack() {
      this.$router.push("/pages/vacations");
    },

    clear() {
      this.actingEmployee = null;
      this.IsAllEmployees = false;
      this.EmployeeId = "";
      this.TypeId = "";
      this.StartOn = null;
      this.FinishOn = null;
      this.Note = "";
      this.btn = "new";
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    handleLike(item) {
      Swal.fire({
        title: `You liked ${item.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "md-button md-success",
      });
    },

    handleEdit(item) {
      const offsetTop = document.getElementById("#content");
      scroll({
        top: offsetTop,
        behavior: "smooth",
      });
      // ff

      this.IsAllEmployees = item.isAllEmployees;
      this.actingEmployee = item.actingEmployee;
      this.EmployeeId = item.employeeId;
      this.TypeId = item.typeId;
      this.StartOn = new Date(item.startOn);
      this.FinishOn = new Date(item.finishOn);
      this.Note = item.note;
      this.btn = "Edit";
      this.idTable = item.id;
    },

    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);
            let result = await axios.delete(
              `${env.HR()}/api/hr/Vacations/${item.id}`,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );
            this.deleteRow(item);
            this.init();
            return this.notifyVue(
              "top",
              "center",
              "success",
              "تم الحذف بنجاح "
            );
          } catch (error) {
            let result =
              error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ];
            return this.notifyVue("top", "center", "danger", result[0]);
          }
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
  },

  watch: {
    IsAllEmployees(neVal) {
      if (neVal) {
        this.EmployeeId = null;
        const selectedType = this.allTypes.find((f) => f.type === 1);
        if (selectedType) {
          this.TypeId = selectedType.id;
        } else {
          this.TypeId = null;
          this.balance = 0;
        }
      } else {
      }
    },
    // EmployeeId() {
    //   if (this.EmployeeId) {
    //     this.disabledType = false;
    //   } else {
    //     this.disabledType = true;
    //   }
    // },

    async TypeId(newVal) {
      if (this.IsAllEmployees) {
        this.balance = 0;
        return;
      }

      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);

      let result_ = await axios.get(
        `${env.HR()}/api/hr/employees/${
          this.EmployeeId
        }/vacation-info?vacationTypeId=${this.TypeId}`,
        {
          headers: { Authorization: "Bearer " + token },
        }
      );
      this.balance = result_.data.data.balance;
    },

    //   try {
    //     let T = localStorage.getItem("Nannotoken");
    //     let token = atob(T);
    //     let result = await axios.get(
    //       `${env.HR()}/api/hr/employees/${this.EmployeeId}/vacation-info`,
    //       {
    //         headers: { Authorization: "Bearer " + token },
    //       }
    //     );
    //     this.balance = result.data.data.balance;
    //   } catch (error) {
    //     return this.notifyVue(
    //       "top",
    //       "center",
    //       "danger",
    //       "الرجاء اعادة تسجيل الدخول"
    //     );
    //   }
    // },
  },

  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["Titel", "SystemVersion"],
      threshold: 0.3,
    });
  },
};
</script>
